<style lang="scss" scoped>
.panel {
	box-shadow: 0 2px 0 rgba(0, 0, 0, 0.1);
	border-radius: 4px;
	background: white;
	&.\--padding {
		padding: 30px;
		@include sm-and-down {
			padding: 15px;
		}
	}
}
</style>

<template lang="pug">
    .panel(v-bind:class="{ '--padding' : padding }")
        slot
</template>

<script>
export default {
	props: {
		padding: {
			type: Boolean,
			default: true
		}
	}
};
</script>
